var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2C7.55827 2 3.91229 5.40686 3.53259 9.75H8.58051C8.92384 8.17741 10.3244 7 11.9999 7C13.6755 7 15.076 8.17741 15.4194 9.75H20.4673C20.0876 5.40686 16.4416 2 11.9999 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4993 18.2485C18.232 17.0125 20.1942 14.3733 20.4673 11.25H15.4194C15.076 12.8226 13.6755 14 11.9999 14C10.3244 14 8.92384 12.8226 8.58051 11.25H3.53259C3.80565 14.3733 5.76791 17.0125 8.50053 18.2485L7.5485 20.6286C7.28575 21.2855 7.76951 22 8.47697 22H15.5229C16.2303 22 16.7141 21.2855 16.4513 20.6286L15.4993 18.2485Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/webcam.aa5abbba74440e7af1706b02dab0bbb1.svg";
export { ForwardRef as ReactComponent };